<template>
  <div class="record"  v-if="isshowRecord">
    <div class="header">
      <el-input style="width: 350px" placeholder="请输入关键词" v-model="search" class="input-with-select"
        prefix-icon="el-icon-search" @input="onSearch">
        <el-button type="primary"  class="btn-p" slot="append" @click="onSearch">查询</el-button>
      </el-input>
      <template v-if="!isSimple">
        <el-button v-if="showRecordBtn" type="primary" style="margin-right:0px" size="medium " @click="showRecord">
          <i class="el-icon-plus el-icon--left"></i>写跟进
        </el-button>
      </template>
    </div>
    <no-data v-if="!totalRecord"></no-data>
    <template v-else>
      <ul class="infinite-list">
        <li v-for="(i, v) in record" :key="v" class="infinite-list-item" @click="editRecord2(i)">
          <div class="list-item">
            <div class="list-item-line" v-if="!isSimple">
              <span class="label">创建人：</span>
              <span class="name">
                {{ i.creater_name }}
              </span>
            </div>
            <div class="list-item-line" v-if="!isSimple">
              <span class="label">联系人：</span>
              <template>
                <span class="name" v-if="i.contacts_name">{{
                  i.contacts_name
                }}</span>
                <span v-else>暂无</span>
              </template>
            </div>
            <div class="list-item-line" v-if="!isSimple">
              <span class="label">商机：</span>
              <template>
                <span class="name" v-if="i.business_name">{{
                  i.business_name
                }}</span>
                <span v-else>暂无</span>
              </template>
            </div>
            <div class="list-item-line">
              <span class="label">跟进记录：</span>
              <span class="name">{{ i.content }}</span>
            </div>
            <div class="list-item-line" v-if="!isSimple">
              <span class="label">所在位置：</span>
              <template>
                <span class="name" v-if="i.address">{{ i.address }}</span>
                <span v-else>暂无</span>
              </template>
            </div>
            <div class="list-item-line" @click.stop v-if="!isSimple">
              <span class="label">打卡照片：</span>
              <template v-if="i.photo.length !== 0">
                <el-image style="width: 40px; height: 30px; margin: 0 5px" v-for="item in i.photo" :key="item" :src="item"
                  :preview-src-list="i.photo"></el-image>
              </template>
              <span v-else>暂无</span>
            </div>
            <div class="list-item-line">
              <span class="label">跟进时间：</span>
              <span class="name">
                {{ i.createtime | formatDate }}
              </span>
            </div>
            <div class="list-item-linelr" v-if="!isSimple">
              <div>
                <span class="label">下次跟进时间</span>
                <span class="name">{{ i.next_time | formatDate }}</span>
              </div>
              <el-button v-if="!isHiddenRoutes.includes($route.matched[0].path)" type="text"
                @click.stop="showComment(i)">点评</el-button>
            </div>
            <div>
              <template v-if="activeIndex === v">
                <div v-for="(item, index) in i.recordCommentList" :key="index" class="infinite-com-item"
                  @click="editComment(item)">
                  <div class="list-com">
                    <el-image class="com-img" :src="item.observer_avatar"></el-image>
                    <div class="com-con">
                      <div class="com-con-u">
                        <span>{{ item.observer_name }}：</span>
                        <span>{{ item.observer_content }}</span>
                      </div>
                      <div class="com-con-d">
                        <span>{{ item.createtime }}&nbsp;&nbsp;</span>
                        <span v-if="i.recordCommentList.length === index + 1"><el-button type="text"
                            @click.stop="closeComment()">收起</el-button></span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="!isSimple">
                <el-button v-if="
                  i.recordCommentList &&
                  i.recordCommentList.length > 0 &&
                  activeIndex !== v
                " type="text" @click.stop="open(v)">评论展示</el-button>
              </template>
            </div>
          </div>
        </li>
      </ul>
      <pagination v-if="isshowRecord" 
      :total="totalRecord" 
      :page.sync="listQueryRecord.page" 
      :limit.sync="listQueryRecord.limit"
      :page-sizes="[10, 20, 50, 100]"
      :auto-scroll="false"
      @pagination="getRecordList" />
    </template>
    <!-- 写跟进记录 -->
    <el-dialog class="record-add" title="新增跟进" :modal-append-to-body="false" :visible.sync="dialogFormVisible">
      <el-form ref="ruleRecord" >
        <el-form-item label="联系人" >
          <el-input v-model="recordData.contacts_name" placeholder="请选择联系人" style="cursor: pointer" readonly
            @click.native="onContact">
            <!-- <template slot="prepend">联系人</template> -->
          </el-input>
        </el-form-item>
        <el-form-item label="商机">
          <el-input v-model="recordData.business_name" placeholder="请选择商机" style="cursor: pointer" readonly
            @click.native="onBusiness">
            <!-- <template slot="prepend">商机</template> -->
          </el-input>
        </el-form-item>
        <el-form-item prop="content" label="备注">
          <el-input v-model="recordData.content" class="record-content item" type="textarea" :clearable="true" :rows="8"
            resize="vertical" required placeholder="勤跟进，多签单......"></el-input>
        </el-form-item>
        <el-form-item label="下次跟进时间" prop="next_time">
          <el-date-picker v-model="recordData.next_time" type="datetime" placeholder="请选择下次跟进时间" align="right" required
            :picker-options="pickerOptionsN"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" style="margin-left:20px" :loading="lockRecordSave" @click="saveRecord">保存</el-button>
      </div>
    </el-dialog>
    <!-- 联系人选择组件 -->
    <mail-list ref="drawer" :module="module" :userid="data.owner" :id="data.id" @handleSelect="handleSelect"></mail-list>
    <!-- 跟进评论 -->
    <el-dialog class="record-add" title="跟进评论" :modal-append-to-body="false" :visible.sync="dialogVisible">
      <el-form>
        <el-form-item >
          <el-input class="pl-input" v-model="recordData.recordCommentListData.observer_content" type="textarea" :clearable="true"
            :rows="8" resize="vertical" required placeholder="请输入评论内容......">请输入评论内容</el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="saveComment">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mailList from '@/components/drawer/mailList';
import Pagination from "@/components/Pagination";
import { recordList, addRecord, editRecord, addComment } from "@/api/common";
export default {
  name: "record",
  components: {
    mailList,
    Pagination,
  },
  props: {
    showRecordBtn: {
      type: Boolean,
      default: true,
    },
    editAuth: {
      type: Boolean,
      default: true,
    },
    editCom: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: true,
    },
    types: {
      type: String,
      require: true,
    },
    isSimple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      dialogVisible: false,
      show: true,
      display: true,
      openComment: false,
      module: "",
      search: "",
      record: [],
      isshowRecord:true,
      lockRecordSave: false,
      submitLoading: false,
      judgeUserid: "",
      recordData: {
        id: 0,
        contacts_id: "",
        contacts_name: "",
        business_id: "",
        business_name: "",
        content: "",
        address: "",
        photo: [],
        recordCommentList: [],
        recordCommentListData: {
          id: 0,
          observer_avater: "",
          observer_name: "",
          observer_content: "",
          createtime: "",
        },

        next_time: new Date(),
      },
      totalRecord: 0,
      listQueryRecord: {
        page: 1,
        limit: 20,
      },
      
      pickerOptionsN: {
        disabledDate: (date) => {
          const time = date.getTime();
          return time < Date.now() - 3600 * 1000 * 24;
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "明天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      activeIndex: "", // 收起索引
      isHiddenRoutes: ["/customerPool", "/cluesPool"], // 控制点评隐藏
    };
  },
  beforeDestroy(){
      this.showRecord=false
  },
  mounted() {
    if (window.localStorage.getItem("crm")) {
      let crm = JSON.parse(window.localStorage.getItem("crm"));
      this.tooken = crm;
    }
    this.getUserid();
    this.getRecordList();
  },
  methods: {
    async getRecordList() {
      const res = await recordList({
        account_id: this.$store.state.user.token.account_id,
        userid: this.data.owner,
        types: this.types,
        types_id: this.data.id,
        page: this.listQueryRecord.page,
        number_page: this.listQueryRecord.limit,
        content: this.search,
      });
      if (res.code == 1) {
        this.totalRecord = res.count;
        this.record = res.data;
        for (let i = 0; i <= this.totalRecord; i++) {
          let photo = res.data[i].photo;
          if (photo) {
            const p = photo.split(",");
            res.data[i].photo = p;
          } else {
            res.data[i].photo = [];
          }
        }
      }
    },
    onSearch() {
      this.totalRecord = 0;
      //this.record = [];
      this.listQueryRecord.page=1
      this.getRecordList();
    },
    showRecord() {
    
      this.initData();
      this.dialogFormVisible = true;
    },
    showComment(data) {
      this.initData();
      this.getItem(data);
      this.dialogVisible = true;
    },
    onContact() {
      // 跟进记录打开联系人选择
      let module;
      if (this.types === "leads") {
        module = "recordContactClues";
      } else if (this.types === "customer") {
        module = "recordContactCustomer";
      }
      this.module = module;
      this.$refs.drawer.open();
    },
    onBusiness() {
      // 跟进记录打开商机选择
      this.module = "businessList";
      this.$refs.drawer.open();
    },
    handleSelect(person) {
      // 跟进记录选择联系人
      if (this.module === "recordContactClues") {
        this.$set(this.recordData, "contacts_id", person.id);
        this.$set(this.recordData, "contacts_name", person.name);
      }
      if (this.module === "recordContactCustomer") {
        this.$set(this.recordData, "contacts_id", person.id);
        this.$set(this.recordData, "contacts_name", person.name);
      }
      // 跟进记录选择商机
      if (this.module === "businessList") {
        this.$set(this.recordData, "business_id", person.id);
        this.$set(this.recordData, "business_name", person.name);
      }
    },
    getItem(data) {
      let date = new Date(data.next_time * 1000);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      let D = date.getDate();
      let H = date.getHours();
      let m = date.getMinutes();
      this.recordData = {
        id: data.id,
        contacts_id: data.contacts_id,
        contacts_name: data.contacts_name,
        business_id: data.business_id,
        business_name: data.business_name,
        content: data.content,
        address: data.address,
        photo: data.photo,
        next_time: new Date(Y, M, D, H, m),
        types_id: data.types_id,
        types: data.types,
        recordCommentListData: {
          id: 0,
          observer_avater: "",
          observer_name: "",
          observer_content: "",
          createtime: "",
        },
      };
    },
    editRecord2(data) {
      if(this.isSimple){
        return false
      }
      if (!this.editAuth) {
        return;
      }
      if (this.$store.state.user.userInfo.if_edit_record === 0) {
        // 后台控制不能编辑
        return;
      }
      if (this.if_leader) {
        // 领导不能编辑
        return;
      }
      this.getItem(data);
      this.dialogFormVisible = true;
    },
    addComment(comData) {
      this.recordData.recordCommentListData = {
        account_id: comData.account_id,
        userid: comData.userid,
        types_id: comData.types_id,
        types: comData.types,
        id: comData.id,
        observer: comData.observer,
        observer_content: comData.observer_content,
      };
      this.dialogVisible = true;
    },
    closeComment() {
      this.openComment = !this.openComment;
      this.display = !this.display;
      this.activeIndex = "";
    },
    open(index) {
      this.activeIndex = index;
    },
    async saveRecord() {
      if (!this.recordData.content) {
        this.$message.error("请填写跟进记录！");
        return;
      }
      if (!this.recordData.next_time) {
        this.$message.error("请填写跟进时间！");
        return;
      }
      const data = {
        account_id: this.$store.state.user.token.account_id,
        userid: this.judgeUserid,
        types: this.types,
        types_id: this.data.id,
        content: this.recordData.content,
        photo: this.recordData.photo,
        next_time: this.recordData.next_time.getTime() / 1000,
        contacts_id: this.recordData.contacts_id,
        business_id: this.recordData.business_id,
      };
      let res;
      this.lockRecordSave = true;
      if (this.recordData.id) {
        res = await editRecord(Object.assign(data, { id: this.recordData.id }));
      } else {
        res = await addRecord(data);
      }

      if (res.code == 1) {
        this.initData();
      }
      setTimeout(() => {
        this.lockRecordSave = false;
      }, 300);
    },
    getUserid() {
      if (this.$route.query.if_leader == 4) {
        this.judgeUserid = this.tooken.userid
      } else {
        this.judgeUserid = this.data.owner
      }
    },
    async saveComment() {
      if (!this.recordData.recordCommentListData.observer_content) {
        this.$message.error("请填写跟进评论！");
        return;
      }

      const data = {
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.user.token.userid,
        types_id: this.recordData.types_id,
        types: this.recordData.types,
        id: this.recordData.id,
        observer: this.$store.state.user.token.userid,
        observer_content: this.recordData.recordCommentListData
          .observer_content,
      };
      let res;
      this.submitLoading = true;
      res = await addComment(Object.assign(data));
      if (res.code == 1) {
        this.initData();
        this.$message({
          message: "评论成功",
          type: "success",
        });
      }
      setTimeout(() => {
        this.submitLoading = false;
      }, 300);
      this.dialogVisible = false;
    },
    initData() {
      this.dialogFormVisible = false;
      this.dialogVisible = false;
      this.record = [];
      this.record.recordCommentList = [];
      this.recordData = {
        id: 0,
        contacts_id: "",
        contacts_name: "",
        business_id: "",
        business_name: "",
        content: "",
        address: "",
        photo: [],
        createtime: "",
        recordCommentListData: {
          account_id: "",
          userid: "",
          types_id: "",
          types: "",
          id: "",
          observer: "",
          observer_content: "",
        },
        next_time: new Date(),
      };
      this.getRecordList();
    },
    
  },
};
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: auto;
  background: #F8F8F8;
  border-radius: 4px;
  padding: 20px;
  margin: 0 20px;
}

.infinite-list {
  overflow: auto;
  .infinite-list-item {
    margin: 20px;
    padding: 30px 20px 10px;
    font-size: 14px;
    line-height: 20px;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px -2px rgba(0,0,0,0.1);
    border-radius: 8px;
    border: 1px solid #F9F9F9;

    .list-item-line {
      margin-bottom: 20px;
      .label {
        color: #888888;
        margin-right: 20px;
      }
      .name{
        color: #333333;
      }
    }
  }
}

.infinite-list-item .list-item-linelr {
  color: #606060;
  display: flex;
  justify-content: space-between;
}

.infinite-list-item .infinite-com-item {
  width: 100%;
  height: 100px;
  margin: 3px 0;
  background-color: #FFFCF5;

  .com-img {
    width: 50px;
    height: 50px;
    margin: 15px 20px;
    border-radius: 50%;
  }

  .com-con {
    color: #606060;

    .com-con-u {
      font-size: 16px;
      padding: 10px 0;
    }
  }
}

.infinite-list-item .infinite-com-item .list-com {
  display: flex;
}

/* 添加跟进记录 */
::v-deep .el-dialog__header {
  height: 56px;

  .el-dialog__title,
  .el-dialog__headerbtn i {
    color: #fff;
  }
}
.name{
  word-break: break-all;
}
.btn-p{
  
  border-radius:8px !important;
  background-color:#49B372 !important;
  color:#ffffff !important;
}
::v-deep .el-dialog__header .el-dialog__title,
::v-deep .el-dialog__header .el-dialog__headerbtn i{
color:#333333;

}
.el-form{
  margin-top: 30px;
}
.el-form-item{
  margin-bottom: 20px;
}
::v-deep .el-form-item__label{
  width: 120px;
  margin-right: 20px;
  font-weight: 400;
  font-size: 16px;
  padding: 0;
}
.el-input{
  width: 80%;
  height: 40px;
}
.el-textarea{
  width: 80%;
}
::v-deep .el-dialog__footer{
  margin-top: 40px;
  padding: 70px 0;
}
::v-deep .el-form-item__content{
  text-align: center;
}
.pl-input{
  width: 90%;
}
.el-button{
  margin: 0px;
}
::v-deep .el-input-group__append{
  padding: 0 ;
}
::v-deep .el-form-item__content{
text-align:left;
}
</style>
